import APIService from "@/services/APIService.js"; 

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/getAll/${includeExpiredRecords}`);
  },
  getById(id) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/getById/${id}`);
  },
  getByStatus(status) {
    status = status.toUpperCase();
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/getByStatus/${status}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/SimulacoesLaudosIncrementais/salvar/${postData.id}`,JSON.stringify(postData))
  },
  executar(id) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/excluir/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/baixarArquivoResultado/${id}`, { responseType: 'blob', ...config });
  },
  baixarLogsTecnicos(id, config = {}) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/baixarLogsTecnicos/${id}`, { responseType: 'blob', ...config });
  },
  baixarArquivoModelo(tipo) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/baixarArquivoModelo/${tipo}`, {
      responseType: 'blob', ... {
        timeout: 60 * 60 * 1000
      }
    });
  },
  duplicar(id) {
    return APIService.apiCall().get(`/SimulacoesLaudosIncrementais/duplicar/${id}`);
  },
};